import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import { useRef, useState } from "react";
import { useEffect } from "react";

export function AppCodesDeliveredAtDateInput({ value, defaultValue, updateInfoPromeCode }) {
  const inputRef = useRef(null);
  const [deliveredAt, setDeliveredAt] = useState(value ? new Date(value) : "");
  const [backUpDeliveredAt, setBackUpDeliveredAt] = useState(value ? new Date(value) : "");
  const [ableToUpdate, setAbleToUpdate] = useState(false);

  const updateDeliveredAt = async () => {
    setAbleToUpdate(false);
    if (deliveredAt === "" || deliveredAt === backUpDeliveredAt) {
      setDeliveredAt(backUpDeliveredAt);
    } else {
      setBackUpDeliveredAt(backUpDeliveredAt);
      updateInfoPromeCode(deliveredAt);
    }
  };

  const handleOnEnterDeliverdAt = (e) => {
    if (e.key === "Enter") updateDeliveredAt();
  };

  useEffect(() => {
    if (ableToUpdate) inputRef.current.focus();
  }, [ableToUpdate]);

  return (
    <VuiBox>
      <VuiBox
        component="input"
        type="date"
        ref={inputRef}
        onChange={(e) => setDeliveredAt(e.target.value)}
        value={deliveredAt}
        placeholder="Escribe tu justificacion"
        sx={{
          fontSize: "12px",
          letterSpacing: "0.5px",
          lineHeight: "15.6px",
          fontWeight: "500",
          color: "#FFF",
          border: "none",
          outline: "none",
          display: ableToUpdate ? "flex" : "none",
          "&::-webkit-calendar-picker-indicator": {
            width: "100%",
            position: "absolute",
            left: "-5px",
            opacity: "0",
          },
        }}
        onBlur={updateDeliveredAt}
        onKeyDown={handleOnEnterDeliverdAt}
        autoFocus
      />
      <VuiBox
        color="white"
        sx={{
          fontSize: "12px",
          letterSpacing: "0.5px",
          lineHeight: "15.6px",
          fontWeight: "500",
          display: "flex",
          whiteSpace: "nowrap",
          display: !ableToUpdate ? "flex" : "none",
        }}
      >
        <VuiTypography
          sx={{
            fontSize: "12px",
            letterSpacing: "0.5px",
            lineHeight: "15.6px",
            fontWeight: "500",
            display: "flex",
            whiteSpace: "nowrap",
            color: "#FFF",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "8.5rem",
          }}
        >
          {!value ? defaultValue : value}
        </VuiTypography>

        <ModeOutlinedIcon
          sx={{
            color: "#A0AEC0",
            marginLeft: "10px",
            cursor: "pointer",
            "&:hover": { color: "#FFF" },
          }}
          onClick={(e) => {
            setAbleToUpdate(!ableToUpdate);
            if (!ableToUpdate) {
              setDeliveredAt(value ? new Date(value) : "");
              setBackUpDeliveredAt(value ? new Date(value) : "");
            }
          }}
        />
      </VuiBox>
    </VuiBox>
  );
}
